import React from 'react';

const successColor = 'bg-[#EFFEF0] text-[#0AA619]';
const failureColor = 'bg-[#FEF5EE] text-[#D5441C]';
const progressColor = 'bg-[#F3FBFF] text-[#0261B6]';
const neutralColor = 'bg-[#F5F7F9] text-[#667085]';
const warningColor = 'bg-yellow-100 text-yellow-500';

const statusConfig: Record<
  string,
  { label: string; color: string; icon?: React.ReactNode }
> = {
  SUBMITTED: { label: 'Submitted', color: neutralColor },
  PENDING: { label: 'Pending', color: progressColor },
  IN_PROCESS: { label: 'In Progress', color: progressColor },
  IN_PROCESS_PARSING: { label: 'Parsing In Progress', color: progressColor },
  IN_PROCESS_KNOWLEDGE: {
    label: 'Knowledge In Progress',
    color: progressColor,
  },
  IN_PROCESS_DEMO: { label: 'Demo In Progress', color: progressColor },
  STARTED: { label: 'Started', color: progressColor },
  SUCCESS: { label: 'Completed', color: successColor },
  SUCCESS_PARSING: { label: 'Parsing Completed', color: successColor },
  SUCCESS_KNOWLEDGE: { label: 'Knowledge Completed', color: successColor },
  SUCCESS_DEMO: { label: 'Demo Completed', color: successColor },
  FAILURE: { label: 'Failed', color: failureColor },
  FAILURE_PARSING: { label: 'Parsing Failed', color: failureColor },
  FAILURE_KNOWLEDGE: { label: 'Knowledge Failed', color: failureColor },
  FAILURE_DEMO: { label: 'Demo Failed', color: failureColor },
  RETRY: { label: 'Retry', color: warningColor },
  REVOKED: { label: 'Revoked', color: warningColor },
  UNKNOWN: { label: 'Unknown', color: neutralColor },
};

type BadgeProps = {
  status: string | null;
  config?: Record<
    string,
    { label: string; color: string; icon?: React.ReactNode }
  >;
  showIconOnly?: boolean;
  className?: string;
};

export const Badge: React.FC<BadgeProps> = ({
  status,
  config = statusConfig,
  showIconOnly = false,
  className = '',
}) => {
  const statusData = config[status || 'UNKNOWN'] || statusConfig.UNKNOWN;
  const { label, color, icon } = statusData;

  if (showIconOnly && icon) {
    return (
      <span
        className={`inline-flex items-center justify-center ${color} ${className}`}
      >
        {icon}
      </span>
    );
  }

  return (
    <span
      className={`px-4 py-2 rounded-full text-sm font-medium ${color} inline-flex items-center gap-2 ${className}`}
    >
      {icon}
      {label}
    </span>
  );
};
